import { CoverPicture, LoadingOverlayWrapper } from 'components';
import * as React from 'react';
import { translate } from 'react-i18next';
import * as c from 'models/constants';
import { WizardSideNav } from 'components/WizzardSideNav';
import { IStore } from 'redux/IStore';
import { reduxForm } from 'redux-form';
import { Link, RouteComponentProps } from 'react-router';
import {
	nextStep,
	previousStep,
	setStep,
	clearFormData,
	addBookingToShoppingBasket,
	setFinalStep,
} from 'redux/modules/bookappointment';
import { BookAppointmentStepCustomers } from './StepCustomers';
import { BookAppointmentStepServicesStaff } from './StepServicesStaff';
import { BookAppointmentStepSchedule } from './StepSchedule';
import { BookAppointmentStepReview } from './StepReview';
import { Dispatch } from 'react-redux';
import { InjectedFormProps, ITranslateProps } from 'models/common';
import { getBookingTemplateVariants } from 'redux/modules/shop/bookingtemplates';
import { getOfficeStaff, getShopCard } from 'redux/modules/shop/shopcard';
// import { reset as resetForm, destroy } from 'redux-form';
import { destroy } from 'redux-form';
import { BookingListItemDto, IAddBookingItemRequest, IBookAppointmentObject } from 'models/bookappointment';
import { closeModal, showModal } from 'redux/modules/modal';
import { getOfficeServiceGroups } from 'redux/modules/shop/serviceGroups';
import { IServicesList } from 'models/shop/shopBookingTemplates';
import { IOfficeMember } from 'models/shop/members';
import { thumbUrl } from 'helpers/common';
import { serviceAndServiceGroupName } from './helpers';
import { resetStripeSession } from 'redux/modules/cart';
import { isRestrictedModeQuery } from 'redux/modules/shop/helpers';
import { groupBy } from 'containers/Shop/Helpers';
const { connect } = require('react-redux');
const config = require('../../../../config/main');

declare var window: any;

interface IParams {
	shopId: string;
	officeId: string;
}

interface IOwnProps extends RouteComponentProps<IParams, {}> {}

interface IState {
	hasSetSkipStaffSelection: boolean;
	skipStaffSelection: boolean;
	stateServices: IServicesList[];
}

const stateToProps = (state: IStore) => ({
	shopCard: state.shopcard.shopcard,
	bookAppointment: state.bookAppointment,
	userPreferences: state.userPreferences,
	fetchingShopCard: state.shopcard.isFetching,
	fetchingBookingTemplates: state.shopBookingTemplates.isFetching,
	shopBookingTemplates: state.shopBookingTemplates,
	fetchingAppointment: state.bookAppointment.isFetching,
	fetchingServiceGroups: state.serviceGroups.isFetching,
	serviceGroups: state.serviceGroups.serviceGroups,
	cart: state.cart,
});

const dispatchToProps = (dispatch: Dispatch<IStore>, ownProps: IOwnProps) => ({
	clearFormData: () => dispatch(clearFormData()),
	destroyForm: () => dispatch(destroy(c.FORM_NAME_BOOKAPPOINTMENT)),
	addBookingToShoppingBasket: (
		data: IAddBookingItemRequest,
		name?: string,
		phoneNumber?: string,
		callingCodeKey?: number,
		currencyKey?: number,
		selectedPayment?: string,
		shopCode?: string,
		restrictedMode?: boolean,
	) =>
		dispatch(
			addBookingToShoppingBasket(
				data,
				name,
				phoneNumber,
				callingCodeKey,
				currencyKey,
				selectedPayment,
				shopCode,
				restrictedMode,
			),
		),
	gotoStep: (step: number) => dispatch(setStep(step)),
	setFinalStep: (step: number) => dispatch(setFinalStep(step)),
	firstStep: () => dispatch(setStep(1)),
	nextStep: () => dispatch(nextStep()),
	previousStep: () => dispatch(previousStep()),
	getShop: () => dispatch(getShopCard(ownProps.params.shopId, false, true)),
	getStaff: () => dispatch(getOfficeStaff(ownProps.params.officeId)),
	getBookingTemplateVariantGroups: (variantParentIds: string[]) =>
		dispatch(getBookingTemplateVariants(variantParentIds, true, true)),
	getServiceGroups: () => dispatch(getOfficeServiceGroups(ownProps.params.officeId)),
	closeModal: () => dispatch(closeModal()),
	showModal: (modalType: string, modalProps: any) => dispatch(showModal(modalType, modalProps)),
	resetStripeSession: () => dispatch(resetStripeSession()),
});

interface IProps
	extends IOwnProps,
		ReturnType<typeof stateToProps>,
		ReturnType<typeof dispatchToProps>,
		ITranslateProps,
		InjectedFormProps {}

@connect(stateToProps, dispatchToProps)
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class BookAppointmentForm extends React.Component<IProps, IState> {
	private instance: any = null;

	constructor(props) {
		super(props);

		this.onSubmit = this.onSubmit.bind(this);
		this.setStaffForService = this.setStaffForService.bind(this);
		this.selectStaffChange = this.selectStaffChange.bind(this);

		this.state = {
			hasSetSkipStaffSelection: false,
			skipStaffSelection: false,
			stateServices: [],
		};
	}

	private async onSubmit(form: IBookAppointmentObject) {
		const appointment = form.selectedAppointment;
		const itemsToRequest: any = [];
		const listItemToRequest = (item: BookingListItemDto): IAddBookingItemRequest => ({
			bookingTemplateId: item.bookingTemplateId,
			schedule: item.schedule,
			resourceId: item.resourceId,
			childrenAddBookingItemRequest: (item.childrenBookings || []).map(listItemToRequest),
		});
		appointment.availableBookings.map((ab) => {
			itemsToRequest.push(listItemToRequest(ab));
		});
		// instead of looping here loop inside bookappointment
		this.props.addBookingToShoppingBasket(
			itemsToRequest,
			form.activeUser ? undefined : form.name + ' ' + form.surname,
			form.activeUser ? form.phoneNumber : form.otherPhoneNumber,
			form.activeUser ? form.callingCodeKey : form.otherCallingCodeKey,
			this.props.shopCard.currencyKey,
			form.selectedPayment,
			this.props.shopCard.code,
			isRestrictedModeQuery(this.props.location),
		);
	}

	private getServicesUrl(queryParams?: { [key: string]: string }) {
		queryParams = queryParams || this.props.location.query;
		const services = decodeURI(queryParams.services).split(',');
		return services;
	}

	public componentDidMount(): void {
		this.instance = window.Stripe(config.app.stripeSettings.publicKey);
		// The form initializes before the below three actions happen which causes it to initialize again if you go from the second step of the booking process to the first again...
		// resetForm(c.FORM_NAME_BOOKAPPOINTMENT);
		// this.props.clearFormData();
		// this.props.destroyForm();
		const bookedOffice = (this.props.shopCard?.offices || []).find((o) => o.id === this.props.params.officeId);
		if (this.props.shopCard?.id !== this.props.params.shopId) {
			this.props.getShop();
		} else if (!bookedOffice?.name) {
			this.props.getShop();
		}
		if (!bookedOffice?.staff) {
			this.props.getStaff();
		}
		this.props.getServiceGroups();
		this.props.getBookingTemplateVariantGroups(this.getServicesUrl()).then(() => {
			this.setState({ stateServices: this.props.shopBookingTemplates.services || [] });
		});
	}

	private servicesHaveOneResource(services: IServicesList[]): boolean {
		if (!services) {
			return false;
		}

		const servicesByVp = groupBy(services, 'variantParentId');

		for (const vpid in servicesByVp) {
			const variations = servicesByVp[vpid];
			// If bundle
			if (variations.length == 1 && variations[0]?.childrenBookingTemplates?.length) {
				if (variations[0].childrenBookingTemplates.find((cbt) => cbt.resources.length > 1)) {
					return false;
				}
			} else {
				if (variations.length != 1) {
					return false;
				}

				if (variations[0].resources.length > 1) {
					return false;
				}
			}
		}
		return true;
	}

	public componentDidUpdate(prevProps: Readonly<IProps>): void {
		const { shopBookingTemplates } = this.props;
		const servicesOld = this.getServicesUrl(prevProps.location.query);
		const servicesNew = this.getServicesUrl();
		if (servicesOld.join(',') !== servicesNew.join(',')) {
			this.props.getBookingTemplateVariantGroups(servicesNew).then(() => {
				this.setState({ stateServices: this.props.shopBookingTemplates.services || [] });
			});
		}
		const bookedOffice = (this.props.shopCard?.offices || []).find((o) => o.id === this.props.params.officeId);
		if (this.props.shopCard?.id !== this.props.params.shopId && !this.props.fetchingShopCard) {
			this.props.getShop();
		} else if (!bookedOffice?.name && !this.props.fetchingShopCard) {
			this.props.getShop();
		}
		if (!bookedOffice?.staff) {
			this.props.getStaff();
		}
		if (prevProps.params.officeId !== this.props.params.officeId) {
			this.props.getServiceGroups();
		}

		if (
			shopBookingTemplates?.isFetching === false &&
			shopBookingTemplates?.services?.length > 0 &&
			this.state.hasSetSkipStaffSelection === false &&
			servicesNew &&
			this.props.params?.officeId
		) {
			const services = this.props.shopBookingTemplates?.services?.filter(
				(s) => s && servicesNew.includes(s.variantParentId) && s.officeId === this.props.params.officeId,
			);
			const allHaveSingleResource: boolean = this.servicesHaveOneResource(services);

			if (allHaveSingleResource === true) {
				// if all services have only one resource (bundles aswell)
				services.forEach((s) => {
					// If bundle / else service
					if (s?.childrenBookingTemplates?.length) {
						s.childrenBookingTemplates.map((cbt) => {
							this.setStaffForService(s.variantParentId, null, cbt.id);
						});
					} else {
						this.setStaffForService(s.variantParentId, null);
					}
				});

				this.setState({ skipStaffSelection: true });
			}

			this.setState({ hasSetSkipStaffSelection: true });
		}

		if (prevProps.cart.paymentSessionId === null && this.props.cart.paymentSessionId !== null) {
			this.instance
				.redirectToCheckout({
					sessionId: this.props.cart.paymentSessionId,
				})
				.then((result) => {
					if (result.error) {
						console.error(result.error.message);
					}
				});
		}
	}

	public componentWillUnmount(): void {
		this.props.resetStripeSession();
		this.props.clearFormData();
		this.props.destroyForm();
	}

	private selectStaffChange = (variantParentId: string) => {
		this.props.showModal('SelectStaffModal', {
			closeModal: this.props.closeModal,
			showHeaderCloseButton: true,
			showModal: this.props.showModal,
			variantParentId,
			officeId: this.props.params.officeId,
			setStaffForService: this.setStaffForService,
			params: this.props.params,
		});
	};

	private setStaffForService(variantParentId: string, resourceId: string | null, childrenBookingId?: string): boolean {
		const { change, shopBookingTemplates } = this.props;
		const selectedServices = shopBookingTemplates.services?.filter((x) => x.variantParentId === variantParentId);
		const fieldName = 'selectStaff.' + variantParentId;
		let targetedService = null;

		// If single service
		if (!childrenBookingId) {
			if (!resourceId) {
				change(fieldName, null);
				return true;
			} else {
				change(fieldName, null); // Reset because of variations (they have a different bookingTemplateId and save differently in form)
			}

			targetedService = selectedServices.find((ss) => ss.resources.some((res: IOfficeMember) => res.id === resourceId));
		} else {
			// If bundle
			targetedService = selectedServices[0].childrenBookingTemplates.find((cbt) => cbt.id === childrenBookingId);

			if (!resourceId) {
				change(fieldName + '.' + targetedService.id, null);
				return true;
			}
		}

		if (!targetedService) {
			return false;
		}

		// add new values
		change(fieldName + '.' + targetedService.id, resourceId);
		return true;
	}

	private displaySideMenuServices = () => {
		const { serviceGroups, t } = this.props;
		// const { services } =  this.props.shopBookingTemplates;
		const { stateServices } = this.state;

		if (stateServices.length === 0) {
			return;
		}

		const groupBy = (arr, property) => {
			return arr.reduce((memo, x) => {
				if (!memo[x[property]]) {
					memo[x[property]] = [];
				}
				memo[x[property]].push(x);
				return memo;
			}, {});
		};

		// Filter lovely variation services
		const filteredServices = stateServices.reduce((accumulator, current) => {
			if (!accumulator.find((item) => item.variantParentId === current.variantParentId)) {
				accumulator.push(current);
			}
			return accumulator;
		}, []);

		const groupedServices = groupBy(filteredServices, 'categoryKey');

		const elements: JSX.Element[] = [];

		// Go through each service category key
		for (const key in groupedServices) {
			const groupElements = groupedServices[key].map((service, i) => {
				const sns = serviceAndServiceGroupName(service, serviceGroups);

				// If subservice
				if (sns.length === 3) {
					return (
						<p key={service.id + i}>
							{sns[0]}
							<span> / </span>
							{sns[1]} <span> / </span>
							{sns[2]}
						</p>
					); // index 0 is the service parent name, index 1 is the service group and index 2 is the service name
				} else {
					// else service
					return (
						<p key={service.id + i}>
							{sns[0]}
							<span> / </span>
							{sns[1]}
						</p>
					); // index 0 is the service parent name and index 1 is the service name
				}
			});

			elements.push(
				<div key={key} className="bookingAppointment__sideMenu__shopAppointments__serviceCategoryGroup">
					<p className="bookingAppointment__sideMenu__shopAppointments__serviceCategoryGroup__title">
						{t(`DV_ServiceCategories_${key}`)}
					</p>
					<div className="bookingAppointment__sideMenu__shopAppointments__serviceCategoryGroup__services">
						{groupElements}
					</div>
				</div>,
			);
		}

		return elements;
	};

	private shopOrderDetailsElement = () => {
		const { shopCard } = this.props;
		const restrictedMode = isRestrictedModeQuery(this.props.location);
		const shopUrl = (restrictedMode ? '/myShop/' : '/shop/') + shopCard?.code;

		return (
			<>
				<Link to={shopUrl}>
					<div className="bookingAppointment__sideMenu__shopInfo">
						<div className="bookingAppointment__sideMenu__shopInfo__profilePictureContainer">
							<CoverPicture
								imageUrl={thumbUrl(shopCard?.picture, 'medium') || ''}
								hasPicture={Boolean(shopCard?.picture)}
								fromShop={true}
							/>
						</div>

						<div className="bookingAppointment__sideMenu__shopInfo__textContainer">
							<p className="shopName">{shopCard?.name}</p>
							<p className="shopLocation">
								{shopCard?.offices.find((office) => office.id === this.props?.params?.officeId)?.name}
							</p>
						</div>
					</div>
				</Link>
				<div className="bookingAppointment__sideMenu__shopAppointments">
					{!this.props.fetchingServiceGroups && this.displaySideMenuServices()}
				</div>
			</>
		);
	};

	public render() {
		const {
			t,
			userPreferences,
			fetchingBookingTemplates,
			fetchingShopCard,
			fetchingAppointment,
			fetchingServiceGroups,
		} = this.props;
		const { wizardStep, finalStep: finalStepRedux } = this.props.bookAppointment;

		const titles = [
			t('BookAppointment_Customer_Title'),
			t('BookAppointment_ServicesStaff_Title'),
			t('BookAppointment_Termin_Title'),
			t('BookAppointment_Overview_Title'),
		].filter((_, i) => !this.state.skipStaffSelection || i != 1);

		const finalStep = this.state.skipStaffSelection ? 2 : 3;
		if (finalStep != finalStepRedux) {
			this.props.setFinalStep(finalStep);
		}
		const wizardProps = (step: number) => ({
			route: this.props.route,
			router: this.props.router,
			params: this.props.params,
			location: this.props.location,
			previousPage: this.props.previousStep,
			onSubmit: step === finalStep ? this.onSubmit : this.props.nextStep,
			userPreferences,
			servicesParentIds: this.getServicesUrl(),
			setStaffForService: this.setStaffForService,
			selectStaffChange: this.selectStaffChange,
			mobileShopOrderDetailsElement: this.shopOrderDetailsElement,
		});

		const stepComponents = [
			BookAppointmentStepCustomers,
			BookAppointmentStepServicesStaff,
			BookAppointmentStepSchedule,
			BookAppointmentStepReview,
		].filter((_, i) => !this.state.skipStaffSelection || i != 1);

		const SelectedStep = stepComponents[wizardStep];

		let isStepSchedule = false;

		if ((this.state.skipStaffSelection && wizardStep === 1) || (!this.state.skipStaffSelection && wizardStep === 2)) {
			isStepSchedule = true;
		}

		return (
			<LoadingOverlayWrapper
				className="container topPadding"
				active={fetchingBookingTemplates || fetchingShopCard || fetchingAppointment || fetchingServiceGroups}
				spinner={true}
				text={t('BSPortal_Common_Loading')}
				background="rgba(0, 0, 0, 0.1)"
				// BookAppointmentStepSchedule needs this, for properly scrollable date cards
				pointerEventsNone={SelectedStep == BookAppointmentStepSchedule}
			>
				<div className="row">
					<aside className="col-lg-3">
						<div className="bookingAppointment__sideMenu">
							{this.shopOrderDetailsElement()}
							<WizardSideNav
								goTo={this.props.gotoStep}
								steps={titles}
								active={wizardStep}
								lastEnabledStep={wizardStep}
								fromBookingProcess={true}
							/>
						</div>
					</aside>
					<main className={`col-lg-9 ${isStepSchedule ? 'col-xl-7' : 'col-xl-6'}`}>
						<div className="bookingAppointment">
							{wizardStep <= finalStep ? (
								<h5>
									{wizardStep + 1}
									<span className="bookingAppointment__stepsGrey">/{finalStep + 1}</span>
								</h5>
							) : null}
							{SelectedStep && <SelectedStep {...wizardProps(wizardStep)} />}
							{/* {wizardStep === 1 && <CreateShopStepLocations {...wizardProps(1)} />}
                            {wizardStep === 2 && <CreateShopStepMembers {...wizardProps(2)} />}
                            {wizardStep === 3 && <CreateShopStepPayment {...wizardProps(3)} />*/}
						</div>
					</main>
				</div>
			</LoadingOverlayWrapper>
		);
	}
}

const BookAppointment = reduxForm({
	form: c.FORM_NAME_BOOKAPPOINTMENT,
	destroyOnUnmount: false,
	forceUnregisterOnUnmount: true,
})(BookAppointmentForm);

export { BookAppointment };
